import { Controller } from '@hotwired/stimulus';
import Logger from '../lib/logger';
// Brings the device controls back after the topology is redrawn by a broadcast.
//
// A regeneration (GenerateTopologyJob — a Generate, an upload, a pull that found a change) replaces the topology
// frame for every viewer with one rendered for no one in particular, so the guide's Run buttons and the Audit tab's
// "Verify on the device" disappear from the page until it is reloaded, and so do an admin's Layered and Flows tabs.
// Mounted only where the page offers either, this waits for that broadcast to render and then reloads the frame from
// the topology page, which renders it again with this viewer's own permissions.
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.listener = (event) => this.intercept(event);
    }
    connect() {
        document.addEventListener('turbo:before-stream-render', this.listener);
    }
    disconnect() {
        document.removeEventListener('turbo:before-stream-render', this.listener);
    }
    intercept(event) {
        const stream = event.target;
        if (!stream || stream.getAttribute('target') !== this.frameValue)
            return;
        if (!['replace', 'update'].includes(stream.getAttribute('action') ?? ''))
            return;
        const detail = event.detail;
        const render = detail.render;
        detail.render = async (element) => {
            await render(element);
            this.reload();
        };
    }
    reload() {
        const frame = document.getElementById(this.frameValue);
        if (!frame)
            return;
        Logger.debug('Reloading the topology frame for this viewer', { controller: this.constructor.name, url: this.urlValue });
        frame.src = this.urlValue;
    }
}
default_1.values = { frame: String, url: String };
export default default_1;
